import { useRouter } from 'next/router';
import React, { useState, useContext, useEffect } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

import HeadWithSocialMedia from 'components/HeadWithSocialMedia/HeadWithSocialMedia';
import SignInForm from 'components/SignInForm/SignInForm';
import SignUpForm from 'components/SignUpForm/SignUpForm';
import ToggleButtonGroup from 'components/ToggleButtonGroup/ToggleButtonGroup';
import { AuthContext } from 'contexts/authContext';

import MainLayout from '../layouts/MainLayout';

interface IProps {
  host: string;
}

const SignIn: React.FC<IProps> = ({ host }) => {
  const router = useRouter();

  const isNewAccountTabActive =
    router.query?.createNewAccountTabActive &&
    router.query.createNewAccountTabActive.toString().toLowerCase() === 'true';

  const { actions, state } = useContext(AuthContext);
  const [tab, setTab] = useState(isNewAccountTabActive ? 'signUp' : 'signIn');
  useEffect(() => actions.initialise(), []);

  useEffect(() => {
    if (state.user && !state.user.isAnonymous) router.push('/');
  }, [state.user]);

  const redirectToHome = () => {
    router.push('/');
  };

  const TABS = [
    {
      id: 'signUp',
      title: 'New Customer',
    },
    {
      id: 'signIn',
      title: 'Existing Customer',
    },
  ];

  return (
    <>
      <HeadWithSocialMedia
        title="Sign in to your Surf Life Saving account"
        description="Sign in to your Surf Life Saving account or create a new account today. Creating an account makes it easier to donate, buy a lottery ticket and download reciepts at tax time."
        thumbnailURL={`${host}/imgs/article_banner.png`}
        url={`${host}/signin`}
        keywords="Surf life Saving Foundation, Sign in"
        canonical_url={`${host}/signin`}
      />
      <MainLayout className="bg-light-grey">
        <section className="py-5 flex-grow-1">
          <Container>
            <Row>
              <Col lg={9} xl={7}>
                <>
                  <h1>Sign in to your Surf account</h1>

                  <ToggleButtonGroup
                    className="my-4"
                    items={TABS}
                    onChange={val => setTab(val)}
                    value={tab}
                  />

                  <Card className="no-rounded-corners mx-n3 mx-md-n5 mx-lg-n1 p-4 p-md-4 p-lg-2 ">
                    <Card.Body>
                      {tab === 'signIn' && (
                        <SignInForm onLoggedIn={redirectToHome} />
                      )}
                      {tab === 'signUp' && (
                        <SignUpForm
                          onSignUp={async (success, userProfile) => {
                            if (!success || !userProfile?.email) {
                              return;
                            }

                            await actions.login({
                              email: userProfile.email,
                              password: userProfile.password,
                            });

                            redirectToHome();
                          }}
                        />
                      )}
                    </Card.Body>
                  </Card>
                </>
              </Col>
            </Row>
          </Container>
        </section>
      </MainLayout>
    </>
  );
};

export default SignIn;
